import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';

import { routes } from './app.routes';
import { AuthInterceptorsService } from './module/core/interceptors/auth/auth-interceptors.service';

export const appConfig: ApplicationConfig = {
  providers: [
    // View transitions + câmera (getUserMedia) costumam gerar AbortError e travar rotas.
    provideRouter(routes),
    provideAnimations(),
    MessageService,
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(NgxSpinnerModule),
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          cssLayer: true,
        },
      },
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorsService,
      multi: true,
    },
  ],
};
